function formatPercent(n: number, d: number): string {
  if (d == null || d <= 0) return '0.0';

  return ((n / d) * 100).toFixed(1);
}

export default formatPercent;
